export default {
    'en' : {
        'btnStart': 'start',
        'btnIncomplete': 'continue',
        'btnCompleted': 'review',
        'btnCompleted2': 'review content',
        'btnReset': 'do again',
        'btnResetAdmin': 'reset progress',
        'btnResetAll': 'reset all progress',
        'btnCancel': 'cancel',
        'btnConfirm': 'ok',
        'btnProfileLabel': 'My accreditation',
        'dlgResetHeader': 'Do again?',
        'dlgResetHeaderAdmin': 'Reset',
        'dlgResetAllHeader': 'Reset all progress',
        'dlgResetBodySingleItem': 'Are you sure you want to do e-learning "${this.catalogName}" again?<br>Your current progress will be lost. It does not affect existing reports.',
        'dlgResetBody': 'Are you sure you want to do e-learning "${this.catalogName}" again?<br>All your current progress will then be lost. It does not affect existing reports.',
        'dlgResetBodyAdmin': 'Are you sure you want to reset this progress?<br>The current progress will then be lost. It does not affect existing reports.',
        'dlgResetAllBody': 'Are you sure you want to reset all progress?<br>The current progress will then be lost. It does not affect existing reports.',
        'dlgResetBodyLastWarning': 'Do "${this.catalogName}" again?',
        'dlgResetBodyLastWarningAdmin': 'Permanently reset "${this.catalogName}" progress?',
        'scormPackageNotEnabled': 'This content is not yet available',
        'titleMovie': 'video',
        'titleAnimation': 'animation',
        'titleAudio': 'audio',
        'titleInfographic': 'infographic',
        'titleExercise': 'exercise',
        'titleMicrocourse': 'microcourse',
        'titleText': 'text',
        'titleTest': 'test',
        'titlePretest': 'assessment',
        'titleComplete': 'e-learning',
        'tabContent': 'Content',
        'tabInfo': 'Info',
        'newWindowMessage': 'This course will be launched in a new window. Please click the button to open the window.',
        'newWindowOpenedMessage': 'The course has been automatically opened in a new window.',
        'startInNewWIndow': 'Click here to start the course',
        'studyMinute':'study minute',
        'studyMinutes':'study minutes',
        'required': 'required',
        'status': 'Status',
        'progress_started': 'Not started',
        'progress_incomplete': 'Incomplete',
        'progress_completed': 'Completed',
        'progress_failed': 'Failed',
        'progress_passed': 'Passed',
        'mandatoryItems_marked': 'Mandatory items',
        'mandatoryItems_noSettings': 'Items completed',
        'mandatoryItems_all': 'All items completed',
        'mandatoryItems_any': 'At least 1 item',
        'mandatoryItems_min': 'At least ${this.num} items',
        'mandatoryItems_durationOnly': 'Items completed (not mandatory)',
        'mandatoryTime': 'Mandatory duration (minutes)',
        'mandatoryStudyMinutes': 'Mandatory study minutes',
        'minute': 'minute',
        'minutes': 'minutes',
        'information': 'Notice',
        'singleItemMessage': 'This e-learning will be launched in a dialog.',
        'registrationSaved': 'The registration numbers have been saved',
        'registrationInstruction': 'Don’t forget to enter the registration numbers that apply to you.',
        'save': 'save',

        'accreditation': 'Accreditation',
        'accreditation_on': 'Enabled',
        'accreditation_off': 'Disabled',
        'status_accreditation_enabled': 'Accreditation enabled',
        'status_accreditation_disabled': 'Accreditation',
        'msg_accreditation_enabled': 'In addition to the required sections, complete at least ${this.minutes} minutes of e-learning content.',
        'msg_accreditation_completed': 'The e-learning has been completed; you can no longer change this setting.',
        'msg_accreditation_disabled': 'Enable accreditation. To qualify, in addition to the required sections, complete at least ${this.minutes} minutes of e-learning content.',
        'status_accreditation_disabled_readonly': 'Accreditation disabled',
        'msg_accreditation_enabled_readonly': 'In addition to the required sections, at least ${this.minutes} minutes of e-learning content are required.',
        'msg_accreditation_disabled_readonly': 'Study minutes do not count towards completing this e-learning.',
        'hdr_accreditation_disable': 'Disable accreditation?',
        'caption_accreditation_disable': 'disable accreditation',
        'warning_accreditation_disable': 'All required sections have been completed.<br><br>If you disable accreditation now, this e-learning will immediately be marked as completed. No accreditation will be granted, and this cannot be changed later.<br><br>If you still want to receive accreditation afterwards, you’ll need to retake the entire e-learning.',
        'warning_no_registration': 'It is not possible to enter registration numbers.',
    },
    'nl': {
        'btnStart': 'starten',
        'btnIncomplete': 'doorgaan',
        'btnCompleted': 'bekijken',
        'btnCompleted2': 'inhoud bekijken',
        'btnReset': 'opnieuw maken',
        'btnResetAdmin': 'reset voortgang',
        'btnResetAll': 'reset alle voortgang',
        'btnCancel': 'annuleren',
        'btnConfirm': 'ok',
        'btnProfileLabel': 'Mijn Accreditatie',
        'dlgResetHeader': 'Opnieuw maken?',
        'dlgResetHeaderAdmin': 'Voortgang resetten?',
        'dlgResetAllHeader': 'Alle voortgang resetten?',
        'dlgResetBodySingleItem': 'Weet je zeker dat je e-learning "${this.catalogName}" opnieuw wilt maken?<br><br>Je huidige voortgang gaat dan verloren. <br><br>Het heeft geen invloed op behaalde resultaten.',
        'dlgResetBody': 'Weet je zeker dat je e-learning "${this.catalogName}" opnieuw wilt maken?<br><br>Je huidige voortgang van deze e-learning en de losse onderdelen gaat dan verloren. De voortgang van dezelde onderdelen in een andere e-learning zal ook worden aangepast. <br><br>Het heeft geen invloed op behaalde resultaten.',
        'dlgResetBodyAdmin': 'Weet je zeker dat je deze voortgang wilt resetten?<br><br>De huidige voortgang gaat dan verloren. Het heeft geen invloed op bestaande rapportages.',
        'dlgResetAllBody': 'Weet je zeker dat je alle voortgang wilt resetten?<br><br>De huidige voortgang gaat dan verloren. Het heeft geen invloed op bestaande rapportages.',
        'dlgResetBodyLastWarning': '"${this.catalogName}" opnieuw maken?.',
        'dlgResetBodyLastWarningAdmin': 'Voortgang van "${this.catalogName}" definitief resetten?.',
        'scormPackageNotEnabled': 'Deze e-learning is nog niet beschikbaar',
        'titleMovie': 'video',
        'titleAudio': 'audio',
        'titleAnimation': 'animatie',
        'titleInfographic': 'infographic',
        'titleExercise': 'oefenen',
        'titleMicrocourse': 'microcursus',
        'titleText': 'tekst',
        'titleTest': 'toets',
        'titlePretest': 'test jezelf',
        'titleComplete': 'e-learning',
        'tabContent': 'Inhoud',
        'tabInfo': 'Informatie',
        'newWindowMessage': 'Deze e-learning zal worden gestart in een nieuw scherm. Klik op onderstaande knop om de e-learning te starten.',
        'newWindowOpenedMessage': 'De e-learning is automatisch geopend in een nieuw scherm.',
        'startInNewWIndow': 'Klik hier om de e-learning te openen',
        'required': 'verplicht',
        'status': 'Status',
        'studyMinute':'studieminuut',
        'studyMinutes':'studieminuten',
        'progress_started': 'Nog niet gestart', // i know
        'progress_incomplete': 'Nog bezig',
        'progress_completed': 'Afgerond',
        'progress_failed': 'Niet voldaan',
        'progress_passed': 'Voldaan',
        'mandatoryItems_marked': 'Verplichte onderdelen',
        'mandatoryItems_noSettings': 'Onderdelen afgerond',
        'mandatoryItems_all': 'Alle onderdelen afgerond',
        'mandatoryItems_any': 'Tenminste 1 onderdeel',
        'mandatoryItems_min': 'Tenminste ${this.num} onderdelen',
        'mandatoryItems_durationOnly': 'Onderdelen afgerond (niet verplicht)',
        'mandatoryTime': 'Verplichte tijdsduur (min)',
        'mandatoryStudyMinutes': 'Verplichte studieminuten',
        'minute': 'minuut',
        'minutes': 'minuten',
        'information': 'Let op',
        'singleItemMessage': 'Deze e-learning wordt direct geopend in een dialoog.',
        'registrationSaved': 'Registratienummers zijn opgeslagen',
        'registrationInstruction': 'Vergeet niet om je registratienummers in te voeren die voor jou van toepassing zijn.',
        'save': 'opslaan',

        'accreditation': 'Accreditatie',
        'accreditation_on': 'Ingeschakeld',
        'accreditation_off': 'Uitgeschakeld',
        'status_accreditation_enabled': 'Accreditatie ingeschakeld',
        'status_accreditation_disabled': 'Accreditatie',
        'msg_accreditation_enabled': 'Voltooi naast de verplichte onderdelen tenminste ${this.minutes} studieminuten aan e-learning onderdelen.',
        'msg_accreditation_completed': 'Accreditatie is uitgeschakeld en de e-learning is afgerond. Je kunt deze instelling niet meer  wijzigen.',
        'msg_accreditation_disabled': 'Zet accreditatie aan. Voltooi voor accreditatie naast de verplichte onderdelen tenminste ${this.minutes} studieminuten aan e-learning onderdelen.',
        'status_accreditation_disabled_readonly': 'Accreditatie uitgeschakeld',
        'msg_accreditation_enabled_readonly': 'Naast de verplichte onderdelen zijn tenminste ${this.minutes} studieminuten aan e-learning onderdelen vereist.',
        'msg_accreditation_disabled_readonly': 'Studieminuten tellen niet mee voor het afronden van deze e-learning.',
        'hdr_accreditation_disable': 'Accreditatie uitschakelen?',
        'caption_accreditation_disable': 'accreditatie uitschakelen',
        'warning_accreditation_disable': 'Alle verplichte onderdelen zijn afgerond.<br><br>Als je de accreditatie nu uitschakelt, wordt deze e-learning meteen als voldaan gemarkeerd. Er wordt dan géén accreditatie toegekend en dit kan later niet meer worden aangepast.<br><br>Wil je na afronding toch accreditatie ontvangen? Dan zul je deze e-learning opnieuw moeten maken.',
        'warning_no_registration': 'Het is niet mogelijk om registratienummers in te voeren.',
   }
}